export default __webpack_public_path__ + "static/IBMPlexSans-Thin-Greek-b0069191d9dd0381e68b4d97c009513d.woff";